const normalizeOptionSku = sku =>
  String(sku || '')
    .trim()
    .toLowerCase()
    .replace(/^jb\d+/, '')
    .replace(/^-/, '');

export default normalizeOptionSku;
